import { useState, useMemo } from 'react';
import { SectionTitle, Badge } from './shared';

interface Skill {
  id: string;
  name: string;
  slug: string;
  summary: string;
  author: {
    name: string;
    avatar: string;
    handle: string;
  };
  downloads: string;
  stars: string;
  versions: string;
  tags?: string[];
  url: string;
}

const skillsData: Skill[] = [
  {
    id: '1',
    name: 'self-improving-agent',
    slug: 'self-improving-agent',
    summary: '捕获学习内容、错误和修正，以实现持续改进。适用场景：(1) 命令或操作意外失败，(2) 用户纠正 Claude...',
    author: { name: 'pskoett', avatar: 'https://avatars.githubusercontent.com/u/177305814?v=4', handle: '@pskoett' },
    downloads: '165k', stars: '1.7k', versions: '14',
    url: 'https://clawhub.ai/pskoett/self-improving-agent',
  },
  {
    id: '2',
    name: 'Find Skills',
    slug: 'find-skills',
    summary: '帮助用户发现和安装代理技能，当他们询问"如何做 X"、"找一个 X 的技能"、"有没有可以...的技能"，或表达对扩展功能的兴趣时使用。',
    author: { name: 'JimLiuxinghai', avatar: 'https://avatars.githubusercontent.com/u/12291132?v=4', handle: '@JimLiuxinghai' },
    downloads: '163k', stars: '696', versions: '1',
    url: 'https://clawhub.ai/JimLiuxinghai/find-skills',
  },
  {
    id: '3',
    name: 'Summarize',
    slug: 'summarize',
    summary: '使用 summarize CLI 总结 URL 或文件（网页、PDF、图像、音频、YouTube）。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '126k', stars: '501', versions: '1',
    url: 'https://clawhub.ai/steipete/summarize',
  },
  {
    id: '4',
    name: 'Agent Browser',
    slug: 'agent-browser',
    summary: '基于 Rust 的快速无头浏览器自动化 CLI，带有 Node.js 后备方案，使 AI 代理能够通过结构化命令导航、点击、输入和截图页面。',
    author: { name: 'TheSethRose', avatar: 'https://avatars.githubusercontent.com/u/10383809?v=4', handle: '@TheSethRose' },
    downloads: '105k', stars: '485', versions: '2',
    url: 'https://clawhub.ai/TheSethRose/agent-browser',
  },
  {
    id: '5',
    name: 'Gog',
    slug: 'gog',
    summary: 'Google Workspace CLI，用于 Gmail、日历、云端硬盘、联系人、表格和文档。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '102k', stars: '700', versions: '1',
    url: 'https://clawhub.ai/steipete/gog',
  },
  {
    id: '6',
    name: 'Github',
    slug: 'github',
    summary: '使用 `gh` CLI 与 GitHub 交互。使用 `gh issue`、`gh pr`、`gh run` 和 `gh api` 处理问题、PR、CI 运行和高级查询。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '94.1k', stars: '310', versions: '1',
    url: 'https://clawhub.ai/steipete/github',
  },
  {
    id: '7',
    name: 'Proactive Agent',
    slug: 'proactive-agent',
    summary: '将 AI 代理从任务执行者转变为能够预测需求并持续改进的主动合作伙伴。现在配备 WAL 协议、工作缓冲区、自主 Crons 和经过实战检验的模式。Hal Stack 的一部分 🦞',
    author: { name: 'halthelobster', avatar: 'https://avatars.githubusercontent.com/u/257232409?v=4', handle: '@halthelobster' },
    downloads: '83.8k', stars: '498', versions: '11',
    url: 'https://clawhub.ai/halthelobster/proactive-agent',
  },
  {
    id: '8',
    name: 'Weather',
    slug: 'weather',
    summary: '获取当前天气和预报（无需 API 密钥）。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '80.7k', stars: '261', versions: '1',
    url: 'https://clawhub.ai/steipete/weather',
  },
  {
    id: '9',
    name: 'Skill Vetter',
    slug: 'skill-vetter',
    summary: 'AI 代理的安全优先技能审查。在从 ClawHub、GitHub 或其他来源安装任何技能之前使用。检查危险信号、权限范围和可疑模式。',
    author: { name: 'spclaudehome', avatar: 'https://avatars.githubusercontent.com/u/257035288?v=4', handle: '@spclaudehome' },
    downloads: '61.6k', stars: '248', versions: '1',
    url: 'https://clawhub.ai/spclaudehome/skill-vetter',
  },
  {
    id: '10',
    name: 'Sonoscli',
    slug: 'sonoscli',
    summary: '控制 Sonos 扬声器（发现/状态/播放/音量/分组）。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '53.9k', stars: '37', versions: '1',
    url: 'https://clawhub.ai/steipete/sonoscli',
  },
  {
    id: '11',
    name: 'Nano Pdf',
    slug: 'nano-pdf',
    summary: '使用 nano-pdf CLI 通过自然语言指令编辑 PDF。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '50.6k', stars: '116', versions: '1',
    url: 'https://clawhub.ai/steipete/nano-pdf',
  },
  {
    id: '12',
    name: 'Notion',
    slug: 'notion',
    summary: 'Notion API，用于创建和管理页面、数据库和块。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '49.7k', stars: '172', versions: '1',
    url: 'https://clawhub.ai/steipete/notion',
  },
  {
    id: '13',
    name: 'Self-Improving Agent (Proactive)',
    slug: 'self-improving',
    summary: '自我反思 + 自我批评 + 自我学习 + 自我组织记忆。代理评估自己的工作，捕获错误，并永久改进。',
    author: { name: 'ivangdavila', avatar: 'https://avatars.githubusercontent.com/u/81719670?v=4', handle: '@ivangdavila' },
    downloads: '49.3k', stars: '230', versions: '16',
    tags: ['Linux', 'macOS', 'Windows'],
    url: 'https://clawhub.ai/ivangdavila/self-improving',
  },
  {
    id: '14',
    name: 'Humanizer',
    slug: 'humanizer',
    summary: '从文本中删除 AI 生成写作的痕迹。在编辑或审查文本时使用，使其听起来更自然和人类化。基于维基百科的综合"AI 写作迹象"指南。',
    author: { name: 'biostartechnology', avatar: 'https://avatars.githubusercontent.com/u/46933184?v=4', handle: '@biostartechnology' },
    downloads: '46k', stars: '356', versions: '1',
    url: 'https://clawhub.ai/biostartechnology/humanizer',
  },
  {
    id: '15',
    name: 'Obsidian',
    slug: 'obsidian',
    summary: '使用 Obsidian 保险库（纯 Markdown 笔记）并通过 obsidian-cli 自动化。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '44.8k', stars: '180', versions: '1',
    url: 'https://clawhub.ai/steipete/obsidian',
  },
  {
    id: '16',
    name: 'Nano Banana Pro',
    slug: 'nano-banana-pro',
    summary: '使用 Nano Banana Pro（Gemini 3 Pro Image）生成/编辑图像。支持文本到图像 + 图像到图像；1K/2K/4K；使用 --input-image。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '43.3k', stars: '181', versions: '2',
    url: 'https://clawhub.ai/steipete/nano-banana-pro',
  },
  {
    id: '17',
    name: 'Openai Whisper',
    slug: 'openai-whisper',
    summary: '使用 Whisper CLI 进行本地语音转文本（无需 API 密钥）。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '39.9k', stars: '190', versions: '1',
    url: 'https://clawhub.ai/steipete/openai-whisper',
  },
  {
    id: '18',
    name: 'API Gateway',
    slug: 'api-gateway',
    summary: '连接到 100+ API（Google Workspace、Microsoft 365、GitHub、Notion、Slack、Airtable、HubSpot 等），带有托管 OAuth。',
    author: { name: 'byungkyu', avatar: 'https://avatars.githubusercontent.com/u/16563684?v=4', handle: '@byungkyu' },
    downloads: '39k', stars: '197', versions: '66',
    url: 'https://clawhub.ai/byungkyu/api-gateway',
  },
  {
    id: '19',
    name: 'Auto-Updater Skill',
    slug: 'auto-updater',
    summary: '每天自动更新 Clawdbot 和所有已安装的技能。通过 cron 运行，检查更新，应用更新，并向用户发送更改摘要消息。',
    author: { name: 'maximeprades', avatar: 'https://avatars.githubusercontent.com/u/509269?v=4', handle: '@maximeprades' },
    downloads: '37.7k', stars: '243', versions: '1',
    tags: ['macOS', 'Linux'],
    url: 'https://clawhub.ai/maximeprades/auto-updater',
  },
  {
    id: '20',
    name: 'Multi Search Engine',
    slug: 'multi-search-engine',
    summary: '多搜索引擎集成，包含 17 个引擎（8 个中文 + 9 个全球）。支持高级搜索运算符、时间过滤器、站点搜索、隐私引擎和 WolframAlpha 知识查询。无需 API 密钥。',
    author: { name: 'gpyAngyoujun', avatar: 'https://avatars.githubusercontent.com/u/10325039?v=4', handle: '@gpyAngyoujun' },
    downloads: '35.9k', stars: '211', versions: '3',
    url: 'https://clawhub.ai/gpyAngyoujun/multi-search-engine',
  },
  {
    id: '21',
    name: 'Brave Search',
    slug: 'brave-search',
    summary: '通过 Brave Search API 进行网络搜索和内容提取。用于搜索文档、事实或任何网络内容。轻量级，无需浏览器。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '35.3k', stars: '138', versions: '2',
    url: 'https://clawhub.ai/steipete/brave-search',
  },
  {
    id: '22',
    name: 'Skill Creator',
    slug: 'skill-creator',
    summary: '创建有效技能的指南。当用户想要创建新技能（或更新现有技能）以通过专业知识、工作流程或工具集成扩展 Claude 的能力时，应使用此技能。',
    author: { name: 'chindden', avatar: 'https://avatars.githubusercontent.com/u/34678156?v=4', handle: '@chindden' },
    downloads: '33.7k', stars: '114', versions: '1',
    url: 'https://clawhub.ai/chindden/skill-creator',
  },
  {
    id: '23',
    name: 'Mcporter',
    slug: 'mcporter',
    summary: '使用 mcporter CLI 直接列出、配置、授权和调用 MCP 服务器/工具（HTTP 或 stdio），包括临时服务器、配置编辑和 CLI/类型生成。',
    author: { name: 'steipete', avatar: 'https://avatars.githubusercontent.com/u/58493?v=4', handle: '@steipete' },
    downloads: '33.4k', stars: '95', versions: '1',
    tags: ['Official'],
    url: 'https://clawhub.ai/steipete/mcporter',
  },
  {
    id: '24',
    name: 'Automation Workflows',
    slug: 'automation-workflows',
    summary: '设计和实施自动化工作流程，以节省时间并作为独立创业者扩展运营。涵盖自动化机会识别、工作流程设计、工具选择（Zapier、Make、n8n）、测试和维护。',
    author: { name: 'JK-0001', avatar: 'https://avatars.githubusercontent.com/u/103896999?v=4', handle: '@JK-0001' },
    downloads: '32.9k', stars: '145', versions: '1',
    url: 'https://clawhub.ai/JK-0001/automation-workflows',
  },
  {
    id: '25',
    name: 'Free Ride - Unlimited free AI',
    slug: 'free-ride',
    summary: '为 OpenClaw 管理来自 OpenRouter 的免费 AI 模型。自动按质量对模型进行排名，配置速率限制处理的后备方案，并更新配置。',
    author: { name: 'Shaivpidadi', avatar: 'https://avatars.githubusercontent.com/u/26166520?v=4', handle: '@Shaivpidadi' },
    downloads: '32.4k', stars: '248', versions: '4',
    url: 'https://clawhub.ai/Shaivpidadi/free-ride',
  },
];

const tagColorMap: Record<string, string> = {
  Linux: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  macOS: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
  Windows: 'bg-teal-500/10 text-teal-400 border-teal-500/20',
  Official: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
};

export default function SkillsDownloadsContent() {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredSkills = useMemo(() => {
    if (!searchQuery.trim()) return skillsData;
    const q = searchQuery.toLowerCase();
    return skillsData.filter(
      (s) =>
        s.name.toLowerCase().includes(q) ||
        s.summary.toLowerCase().includes(q) ||
        s.slug.toLowerCase().includes(q) ||
        s.author.handle.toLowerCase().includes(q),
    );
  }, [searchQuery]);

  return (
    <div>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-3">技能下载</h1>
        <p className="text-slate-400 text-sm leading-relaxed">
          浏览技能库，按下载量排序。共{' '}
          <span className="text-cyan-400 font-semibold">{skillsData.length}</span> 个技能，
          点击任意卡片可跳转到 ClawHub 查看详情。
        </p>
      </div>

      {/* Search */}
      <div className="relative mb-6">
        <div className="w-5 h-5 flex items-center justify-center absolute left-3.5 top-1/2 -translate-y-1/2">
          <i className="ri-search-line text-slate-500 text-base"></i>
        </div>
        <input
          type="text"
          placeholder="按名称、slug、摘要或作者过滤..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 bg-slate-800/60 border border-slate-700/60 rounded-lg text-sm text-slate-200 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 focus:bg-slate-800 transition-colors"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}
            className="w-5 h-5 flex items-center justify-center absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-base"></i>
          </button>
        )}
      </div>

      {/* Result count */}
      {searchQuery && (
        <div className="mb-4 text-xs text-slate-500">
          找到 <span className="text-cyan-400 font-medium">{filteredSkills.length}</span> 个匹配结果
        </div>
      )}

      {/* Skills List */}
      <div className="space-y-2">
        {filteredSkills.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-12 h-12 flex items-center justify-center mb-4">
              <i className="ri-search-line text-4xl text-slate-600"></i>
            </div>
            <p className="text-slate-500 text-sm">未找到匹配的技能</p>
            <button
              onClick={() => setSearchQuery('')}
              className="mt-3 text-xs text-cyan-400 hover:text-cyan-300 cursor-pointer transition-colors"
            >
              清除搜索
            </button>
          </div>
        ) : (
          filteredSkills.map((skill, index) => (
            <a
              key={skill.id}
              href={skill.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-start gap-4 bg-slate-800/30 border border-slate-700/40 rounded-xl px-5 py-4 hover:border-cyan-500/30 hover:bg-slate-800/60 transition-all cursor-pointer"
            >
              {/* Rank */}
              <div className="w-7 flex-shrink-0 text-center pt-0.5">
                <span className={`text-xs font-mono font-bold ${index < 3 ? 'text-cyan-400' : 'text-slate-600'}`}>
                  #{index + 1}
                </span>
              </div>

              {/* Author Avatar */}
              <img
                src={skill.author.avatar}
                alt={skill.author.name}
                className="w-8 h-8 rounded-full flex-shrink-0 mt-0.5 border border-slate-700"
                loading="lazy"
              />

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-sm font-semibold text-white group-hover:text-cyan-400 transition-colors">
                    {skill.name}
                  </span>
                  <code className="text-xs text-slate-500 font-mono hidden sm:inline">
                    {skill.slug}
                  </code>
                  {skill.tags?.map((tag) => (
                    <span
                      key={tag}
                      className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium border ${tagColorMap[tag] ?? 'bg-slate-500/10 text-slate-400 border-slate-500/20'}`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="text-xs text-slate-400 leading-relaxed line-clamp-2 mb-2">
                  {skill.summary}
                </p>
                <div className="flex items-center gap-1 text-xs text-slate-600">
                  <span>by</span>
                  <span className="text-slate-500">{skill.author.handle}</span>
                </div>
              </div>

              {/* Stats */}
              <div className="flex flex-col items-end gap-1.5 flex-shrink-0 text-xs">
                <div className="flex items-center gap-1.5 text-slate-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-download-line text-cyan-500 text-xs"></i>
                  </div>
                  <span className="font-semibold text-slate-300">{skill.downloads}</span>
                </div>
                <div className="flex items-center gap-1.5 text-slate-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-line text-amber-500 text-xs"></i>
                  </div>
                  <span>{skill.stars}</span>
                </div>
                <div className="flex items-center gap-1.5 text-slate-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-git-branch-line text-xs"></i>
                  </div>
                  <span>v{skill.versions}</span>
                </div>
              </div>
            </a>
          ))
        )}
      </div>

      {/* Footer hint */}
      {filteredSkills.length > 0 && (
        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-slate-600">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-external-link-line"></i>
          </div>
          <span>显示 {filteredSkills.length} 个技能 · 点击卡片跳转至 ClawHub 查看详情</span>
        </div>
      )}
    </div>
  );
}
